import { render, staticRenderFns } from "./AddTarjetaDictamen.vue?vue&type=template&id=3e91530a&"
import script from "./AddTarjetaDictamen.vue?vue&type=script&lang=js&"
export * from "./AddTarjetaDictamen.vue?vue&type=script&lang=js&"
import style0 from "./AddTarjetaDictamen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports